import { Component, OnInit, OnChanges, Input, SimpleChanges, OnDestroy, Inject, LOCALE_ID } from '@angular/core';
import { ReportService } from '../../service/report.service';
import { Report } from '../../model/report.model';
import { PdfService } from '../../service/pdf.service';
import { SubscriptionService } from '../../service/subscription.service';
import 'parse';
import { SubmenuOption } from '../submenu/submenu.component';
import { Router } from '@angular/router';
import { Settings } from '../../model/settings.model';
import { ParametersService } from '../../service/parameters.service';
const parse: typeof Parse = require('parse');
import { I18n } from '@ngx-translate/i18n-polyfill';
import { ToastService } from '../../service/toast.service';
import { Subscription } from 'rxjs';
import { environment } from '../.././../environments/environment';
import { SelectPossibleOption } from '../../model/search';
import { RoiService } from '../../service/roi.service';

@Component({
  selector: 'app-report-summary',
  templateUrl: './report-summary.component.html',
  styleUrls: ['./report-summary.component.less']
})
export class ReportSummaryComponent implements OnInit, OnChanges {
  @Input() reportId: string;
  @Input() report: Report;
  wayOptionsSelect: SelectPossibleOption[];
  typeReportOptionsSelect: SelectPossibleOption[];
  ctaAction: string;
  reportBuildProgress: number;
  isBuildingPdf: boolean;
  submenuOptions: SubmenuOption[];
  timerEvent: NodeJS.Timer;
  isSuperAdmin = false;
  settings: Settings;
  showSignatory: boolean = true;
  subscription: Subscription;

  constructor(
    private readonly i18n: I18n,
    private readonly _reportService: ReportService,
    private readonly _pdfService: PdfService,
	private readonly _roiService : RoiService,
    private readonly _subscriptionService: SubscriptionService,
    private readonly _routerService: Router,
    private readonly _parametersService: ParametersService,
    private readonly _toastService: ToastService,
    @Inject(LOCALE_ID) private locale: string,

  ) {
    this.settings = this._parametersService.getAll();

    this.isSuperAdmin = this._parametersService.isSuperAdmin

    this.wayOptionsSelect = [
      {
        key: 'in', value: this.i18n({
          id: 'wayOptionsSelect_in',
          value: 'Entrant',
          description: 'Entrant',
          meaning: 'report_summary'
        })
      },
      {
        key: 'out', value: this.i18n({
          id: 'wayOptionsSelect_out',
          value: 'Sortant',
          description: 'Sortant',
          meaning: 'report_summary'
        })
      }
    ];
    this.typeReportOptionsSelect = [
      {
        key: 'simple', value: this.i18n({
          id: 'typeReportOptionsSelect_simple',
          value: 'Simple',
          description: 'Simple',
          meaning: 'report_summary'
        })
      },
      {
        key: 'state', value: this.i18n({
          id: 'typeReportOptionsSelect_state',
          value: 'Etat des Lieux',
          description: 'Etat des Lieux',
          meaning: 'report_summary'
        })
      }
    ];

    this.submenuOptions = [
      {
        labelFr: this.i18n({
          id: 'submenuOptions_openPlayer',
          value: 'Ouvrir le Player',
          description: 'Ouvrir le Player',
          meaning: 'report_summary'
        }),
        handler: () => {
          _routerService
            .navigate(['/player', this.report.tchekPtr.id, 1, 0])
            .then(success => !success && console.log('Navigation failed'))
            .catch(e => console.error(e));
        }
      }
    ];
    if (this.ctaAction != "checksi") {
      this.submenuOptions.push({
        labelFr: this.i18n({
          id: 'submenuOptions_sendToSi',
          value: 'Notifier SI',
          description: 'Notifier SI',
          meaning: 'report_summary'
        }),
        handler: () => {
          // TODO: call VPAuto API
          this._reportService.notifySI(this.report.tchekPtr.id)
        }
      })
    }
  }

  filters() {
    if (this.report) {
      if (this.report.typeReport === 'simple') {
        this.showSignatory = this.settings.report.simple.signatory;
      } else {
        this.showSignatory = this.settings.report.state.signatory;
      }
      if (this.showSignatory === undefined)
        this.showSignatory = true;
    }
  }

  ngOnInit() {
    if (this.settings && this.settings.report) {
      this.ctaAction = this.settings.report.selectorButton ? this.settings.report.selectorButton : "openpdf";
    } else {
      this.ctaAction = 'openpdf';
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.reportId && changes.reportId.currentValue) {
      this._reportService.get(changes.reportId.currentValue)
        .then(report => {
          this.report = report
          this.filters()
        });
    }
  }


  handleContractWayValue(newValue: string) {
    this.report.contractWay = newValue as ('in' | 'out');
    if (this.report.contractWay === 'in' && this.report.typeReport === 'state') {
      this._reportService.getOutReport(this.report).then(result => {
        // console.log("dove", result);
        if (result === "error") {
          this._toastService.toastOpen(undefined, this.i18n({
            id: 'outputNotFound',
            value: "Rapport de sortie introuvable.",
            description: "Rapport de sortie introuvable.",
            meaning: "report_summary"
          }), "error");
          this.report.contractWay = 'out';
          return
        } else
          this.saveData();
      }
      )
    } else {
      this.saveData();
    }
  }

  handleTypeReportValue(newValue: string) {
    this.report.typeReport = newValue as ('simple' | 'state');
    this.saveData();
  }

  reportValue(): String {
    if (this.report.typeReport === undefined || this.report.typeReport === 'simple') return 'Simple'
    else return this.i18n({
      id: 'typeReportOptionsSelect_state',
      value: 'Etat des Lieux',
      description: 'Etat des Lieux',
      meaning: 'report_summary'
    });

  }

  saveData() {
    this._toastService.toastOpen(true);
    clearTimeout(this.timerEvent);
    this.timerEvent = setTimeout(() => {
      this._reportService.save(this.report).then((saved: Report) => {
        this.report = saved;

        //console.log("save Report settings", this.report)
        this._toastService.toastOpen(false);
      });
    }, 500);
  }

  async handleSendPdf() {

	 console.log('aaaa', this.report.tchekPtr, environment.isLocal, this.locale);

	if (this.report && !environment.isLocal
    // shortcutting to move all reports to FrontV3 report (via liveapi link)
    // since PDF report generation on apiServer is not working anymore on EBS
		/*&& ([4,5].includes(this.report.tchekPtr.type)
		|| (this.report.tchekPtr.type === 0 && this.isSuperAdmin )
		)*/
    ){
			const link = await this._roiService.getToken(this.report.tchekPtr.getParseInstance());
  			window.open(`${environment.frontV3Host}/${this.locale || 'en'}/report?token=${link}`, '_blank').focus();
			return;
		}

    // Don't request a PDF build if another PDF is being built
    if (this.isBuildingPdf || !this.reportId)
      return;


    this.isBuildingPdf = true;
    this._pdfService.requestDamagePDFFromReport(this.reportId).then(response => {
      if (response.ok) {
        // Setting up LiveQueries
        const query = new parse.Query('Report');
        query.equalTo('objectId', response.report.id);
        this._subscriptionService.sub(query, 'reportProgress');
        this._subscriptionService.listen('reportProgress', 'update', r => {
          this.reportBuildProgress = r.get('progress');
          if (this.reportBuildProgress === 100) {
            this._subscriptionService.unsub('reportProgress');
            this.isBuildingPdf = false;
            this._pdfService.downloadReport(r.id).then(downloadResponse => {
              const downloadAnchor = document.createElement('a');
              downloadAnchor.setAttribute('href', downloadResponse.fileUrl);
              downloadAnchor.setAttribute('download', downloadResponse.fileName);
              downloadAnchor.setAttribute('target', '_blank');
              downloadAnchor.style.display = 'none';
              document.body.appendChild(downloadAnchor);
              downloadAnchor.click();
              document.body.removeChild(downloadAnchor);
            }, error => {
              console.error('Cannot download PDF:', error);
              this.isBuildingPdf = false;
              this.reportBuildProgress = 0;
            });
          }
        }
        );
      }
    }, error => {
      console.error('PDF build request failed', error);
      this.isBuildingPdf = false;
      this.reportBuildProgress = 0;
    });

  }


  handleSendPdfNew(allDamages?: boolean) {
    // Don't request a PDF build if another PDF is being built
    if (this.isBuildingPdf || !this.reportId)
      return;


    this.isBuildingPdf = true;
    this._pdfService.requestDamagePDFFromReport(this.reportId).then(response => {
      if (response.ok) {
        // Setting up LiveQueries
        const query = new parse.Query('Report');
        query.equalTo('objectId', response.report.id);
        this._subscriptionService.sub(query, 'reportProgress');
        this._subscriptionService.listen('reportProgress', 'update', r => {
          this.reportBuildProgress = r.get('progress');
          if (this.reportBuildProgress === 100) {
            this._subscriptionService.unsub('reportProgress');
            this.isBuildingPdf = false;
            this._pdfService.downloadReport(r.id).then(downloadResponse => {

              setTimeout(() => {
                const downloadAnchor = document.createElement('a');
                downloadAnchor.setAttribute('href', downloadResponse.fileUrl);
                downloadAnchor.setAttribute('download', downloadResponse.fileName);
                downloadAnchor.setAttribute('target', '_blank');
                downloadAnchor.style.display = 'none';
                document.body.appendChild(downloadAnchor);
                downloadAnchor.click();
                document.body.removeChild(downloadAnchor);
              }, 2000);

            }, error => {
              console.error('Cannot download PDF:', error);
              this.isBuildingPdf = false;
              this.reportBuildProgress = 0;
            });
          }
        }
        );
      }
    }, error => {
      console.error('PDF build request failed', error);
      this.isBuildingPdf = false;
      this.reportBuildProgress = 0;
    });

  }



  handleSendToVPA() {
    this._reportService.notifySI(this.report.tchekPtr.id)
  }

  handleSubmenuSelection(e: number) {
    this.submenuOptions[e].handler();
  }

  signatoryFullName() {
    if (!this.report)
      return '-';
    else if (!this.report.signatoryFirstName && !this.report.signatoryLastName)
      return '-';

    return `${this.report.signatoryFirstName || ''} ${this.report.signatoryLastName || ''}`;
  }

  operatorFullName() {
    if (!parse.User.current())
      return '-';
    else if (!parse.User.current().get('firstname') && !parse.User.current().get('lastname'))
      return '-';

    return `${parse.User.current().get('firstname') || '-'} ${parse.User.current().get('lastname') || ''}`;
  }
}



// WEBPACK FOOTER //
// ./src/app/element/report-summary/report-summary.component.ts